import { usePreference } from './usePreference';

export type UIPreferenceKey = 'theme' | 'sidebar' | 'density';

export function useUIPreference<T>(key: UIPreferenceKey, defaultValue: T) {
  return usePreference<T>(`ui.${key}`, defaultValue);
}
